/**
 * tolling-api v2
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ActivityPricingBreakdownResponseDto } from './activityPricingBreakdownResponse';

export interface ActivityPricingItemResponseDto {
    type?: ActivityPricingItemResponseDto.TypeEnum;
    name?: string;
    amount?: number;
    breakdown?: ActivityPricingBreakdownResponseDto | null;
}
export namespace ActivityPricingItemResponseDto {
    export const TypeEnum = {
        TollRoadAmount: 'TOLL_ROAD_AMOUNT',
        NextpassFee: 'NEXTPASS_FEE',
        WalletCredit: 'WALLET_CREDIT',
        Promotion: 'PROMOTION',
    } as const;
    export type TypeEnum = (typeof TypeEnum)[keyof typeof TypeEnum];
}
